export const noButton = 'No';
export const yesButton = 'Yes';
